import styled from "styled-components";
import {Select, Tabs} from "antd";
export const SelectField = styled(Select)`
    width: 100%;
    margin-bottom: 20px;
`;

export const TabRow = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    margin-top: 60px;
    margin-bottom: 60px;
    gap: 30px;

    @media (max-width: 992px) {
        gap: 10px;
    }

    @media (max-width: 768px) {
        flex-wrap: wrap;
        height: auto;
        gap: 10px;
    }
`;
export const CustomTab = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    width: 178px;
    height: 160px;
    border-radius: 5px;
    text-align: center;
    padding: 4px;
    padding-top: 16px;
    padding-bottom: 16px;
    font-size: 16px;
    font-weight: ${$props => ($props.isActive ? "bold" : "normal")};

    /* Kapıda ödeme tasarımı */
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
    border: ${$props => ($props.isActive ? "1px solid #91d5ff" : "none")};
    background-color: ${$props => ($props.isActive ? "#e6f7ff" : "white")};

    cursor: pointer;
    transition: all 0.3s ease;

    b {
        line-height: 1.2;
    }

    img {
        width: 100%;
        max-height: 50px;
    }

    /* Tab içindeki sayı ve etiket düzeni */
    > div:last-child {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 4px;

        > div:first-child {
            font-size: 24px;
            font-weight: bold;
            color: #000;
            line-height: 1;
        }

        > div:last-child {
            font-size: 14px;
            font-weight: 500;
            color: #666;
            line-height: 1;
        }
    }

    &:hover {
        background-color: ${$props => ($props.isActive ? "#e6f7ff" : "#f7f7f7")};
    }

    @media (min-width: 992px) and (max-width: 1440px) {
        width: 150px;
        height: 140px;
        padding: 3px;
        padding-top: 14px;
        padding-bottom: 14px;
        font-size: 15px;

        img {
            max-height: 42px;
        }

        > div:last-child {
            > div:first-child {
                font-size: 22px;
            }
            > div:last-child {
                font-size: 13px;
            }
        }
    }

    @media (min-width: 768px) and (max-width: 992px) {
        width: 130px;
        height: 120px;
        padding: 3px;
        padding-top: 12px;
        padding-bottom: 12px;
        font-size: 14px;
        gap: 6px;

        img {
            max-height: 36px;
        }

        > div:last-child {
            > div:first-child {
                font-size: 20px;
            }
            > div:last-child {
                font-size: 12px;
            }
        }
    }

    @media (min-width: 480px) and (max-width: 768px) {
        width: 110px;
        height: 100px;
        padding: 2px;
        padding-top: 10px;
        padding-bottom: 10px;
        font-size: 13px;
        gap: 4px;

        img {
            max-height: 30px;
        }

        > div:last-child {
            > div:first-child {
                font-size: 18px;
            }
            > div:last-child {
                font-size: 11px;
            }
        }
    }

    @media (max-width: 480px) {
        width: 90px;
        height: 85px;
        padding: 2px;
        padding-top: 8px;
        padding-bottom: 8px;
        font-size: 12px;
        gap: 3px;

        img {
            max-height: 24px;
        }

        > div:last-child {
            > div:first-child {
                font-size: 16px;
            }
            > div:last-child {
                font-size: 10px;
            }
        }
    }
`;
